import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';
import { Typography } from '@mui/material';

const MarkdownRenderer = ({ content, typography = {} }) => {
  // Handle undefined or empty content
  const safeContent = content || '';

  return (
    <Typography component="div" sx={typography}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          h1: ({ node, ...props }) => <Typography variant="h5" gutterBottom {...props} />,
          h2: ({ node, ...props }) => <Typography variant="h6" gutterBottom {...props} />,
          h3: ({ node, ...props }) => <Typography variant="subtitle1" gutterBottom fontWeight="bold" {...props} />,
          ul: ({ node, ...props }) => <ul style={{ marginLeft: '1.5rem' }} {...props} />,
          ol: ({ node, ...props }) => <ol style={{ marginLeft: '1.5rem' }} {...props} />,
          li: ({ node, ...props }) => <li style={{ marginBottom: '0.25rem' }} {...props} />,
          p: ({ node, ...props }) => <Typography variant="body2" paragraph {...props} />,
          a: ({ node, ...props }) => <a style={{ color: 'inherit', textDecoration: 'underline' }} {...props} />,
        }}
      >
        {safeContent}
      </ReactMarkdown>
    </Typography>
  );
};

export default MarkdownRenderer;
